import { Pipe, PipeTransform } from '@angular/core';
import { SharedService } from '../shared.service';
import { TranslationService } from '../translation/translation.service';

@Pipe({
	name: 'tylTranslate'
})
export class TylTranslatePipe implements PipeTransform {

	constructor(private sharedService: SharedService,
				private translationService: TranslationService) { }

	transform(englishToTranslate: string): string {

		if(!this.translationService.overrideTranslationPipe) {
			let index: number = this.translationService.currentLanguageTranslations.findIndex(o => o.English.trim() == englishToTranslate.trim());

			if(index != -1) {
				return this.translationService.currentLanguageTranslations[index].Translation;
			}
		}
		else {
			if(this.translationService.revertToEnglish) {
				let index: number = this.translationService.currentLanguageTranslations.findIndex(o => o.Translation && o.Translation.trim() == englishToTranslate.trim());

				if(index != -1) {
					return this.translationService.currentLanguageTranslations[index].English;
				}
			}
			else {
				let index: number = this.translationService.overrideTranslations.findIndex(o => o.English.trim() == englishToTranslate.trim());

				if(index != -1) {
					return this.translationService.overrideTranslations[index].Translation;
				}
			}
		}

		return englishToTranslate;
	}
}
